<template>
  <div class="login-page">
    <div class="login-card">
      <h1 class="login-title">智慧清掏监管平台</h1>
      <p class="login-subtitle">数据大屏登录</p>
      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        class="login-form"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model.trim="form.username"
            aria-label="账号"
            autocomplete="username"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            aria-label="密码"
            autocomplete="current-password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            type="password"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button
          :loading="loading"
          class="login-submit"
          native-type="submit"
          type="primary"
        >
          登 录
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from "../../utils/request";
import { clearAuth, setTenantId, setToken } from "../../utils/auth";

export default {
  name: "BigScreenLogin",
  data() {
    return {
      loading: false,
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 仅允许站内相对路径，防止 redirect 参数被用作外跳
    getRedirect() {
      const redirect = this.$route.query.redirect;
      if (
        typeof redirect === "string" &&
        redirect.startsWith("/") &&
        !redirect.startsWith("//") &&
        !redirect.startsWith("/login")
      ) {
        return redirect;
      }
      return "/index";
    },
    handleLogin() {
      if (this.loading) return;
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return;
        this.loading = true;
        try {
          clearAuth();
          // 复用 PC 端登录接口：不传 loginEntry，企业/政府/平台账号均可登录大屏
          const res = await login({
            username: this.form.username,
            password: this.form.password,
          });
          const body = res.data || {};
          if (body.code !== 0 || !body.data) {
            this.$message.error(body.msg || "登录失败");
            return;
          }
          setToken(body.data);
          setTenantId(body.data.tenantId);
          this.$router.replace(this.getRedirect());
        } catch (e) {
          this.$message.error("网络异常，请稍后重试");
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle at 50% 30%, #1d3b5a 0%, #0f1a26 70%);
}

.login-card {
  width: 420px;
  padding: 40px 36px 32px;
  border: 1px solid rgba(64, 158, 255, 0.35);
  border-radius: 8px;
  background: rgba(16, 32, 52, 0.85);
  box-shadow: 0 0 30px rgba(0, 120, 255, 0.25);
}

.login-title {
  margin: 0;
  color: #e6f4ff;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
}

.login-subtitle {
  margin: 8px 0 28px;
  color: #8fb8dd;
  font-size: 14px;
  text-align: center;
}

.login-form {
  /deep/ .el-input__inner {
    height: 44px;
    border-color: rgba(64, 158, 255, 0.4);
    background: rgba(255, 255, 255, 0.06);
    color: #e6f4ff;
  }

  /deep/ .el-input__inner:focus {
    border-color: #409eff;
  }
}

.login-submit {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  font-size: 16px;
}
</style>
